import { List, Skeleton } from 'antd';
import { NftCardSkeleton } from 'components/Shared/NftCard/Skeleton';
import * as Styled from './styles';
import { itemsMockData } from 'constants/mockData/items';

interface IListItem {
  name: string;
  value: string;
}

const dataSource: IListItem[] = [
  {
    name: 'Owned',
    value: '22'
  },
  {
    name: 'Created',
    value: '4'
  }
];

export const ArtistSkeleton = () => {
  return (
    <Styled.SkeletonWrapper>
      <div className="container_v3 container-fluid_v3">
        <div className="col_v3-xs-12 col_v3-sm-12 col_v3-md-12 col_v3-lg-12">
          <Styled.CardContent>
            <Skeleton.Button
              active
              block
              style={{
                paddingBottom: '32.94%',
                borderRadius: '16px'
              }}
            />
            <Styled.ArtistAvatar>
              <Skeleton.Avatar
                active
                style={{ height: '110px', width: '110px' }}
              />
            </Styled.ArtistAvatar>
          </Styled.CardContent>
          <Styled.ArtistInfo>
            <Styled.Info>
              <Skeleton
                active
                style={{
                  width: '98%',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
                title={{
                  style: {
                    width: '50%',
                    height: '36px',
                    margin: '4px 0 8px 5px'
                  }
                }}
                paragraph={{
                  rows: 1,
                  style: {
                    width: '100%',
                    height: '16px',
                    margin: '0 0 0 5px'
                  }
                }}
              />
              <Skeleton
                active
                style={{
                  width: 'calc(100% - 5px)',
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: '20px'
                }}
                title={false}
                paragraph={{
                  rows: 3,
                  style: {
                    height: '24px',
                    margin: '0 0 5px 5px'
                  }
                }}
              />
            </Styled.Info>
            <Styled.Statistics>
              <Styled.ListBlock
                size="small"
                dataSource={dataSource}
                renderItem={i => {
                  const item = i as IListItem;
                  return (
                    <List.Item key={item.name}>
                      <Skeleton
                        active
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                        title={{
                          style: {
                            width: '50%',
                            height: '14px'
                          }
                        }}
                        paragraph={false}
                      />
                    </List.Item>
                  );
                }}
              />
            </Styled.Statistics>
          </Styled.ArtistInfo>
        </div>

        <div className="col_v3-xs-12 col_v3-sm-12 col_v3-md-7 col_v3-lg-7">
          <div className="row_v3">
            <div className="col_v3-xs-12 col_v3-sm-12 col_v3-md-5 col_v3-lg-5">
              <Skeleton.Button
                active
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  height: '40px',
                  marginBottom: '20px'
                }}
              />
            </div>
          </div>
          <div className="row_v3">
            {itemsMockData.map(item => (
              <div
                key={item.id}
                className="col_v3-xs-12 col_v3-sm-6 col_v3-md-4 col_v3-lg-4"
              >
                <NftCardSkeleton />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Styled.SkeletonWrapper>
  );
};
